import React from "react";
import { MapPin, ExternalLink, Phone, MessageCircle, Shirt } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { SectionLayout, SectionIntro } from "@/components/SectionLayout";

export const MapsNav = ({ data }) => {
  const { L, t } = useLang();
  if (!data) return null;
  const laundry = data.laundry;

  const LaundryList = ({ items, cityLabel }) =>
    items && items.length ? (
      <div className="mt-3">
        <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.16em] text-[#3E6B9A]">{cityLabel}</p>
        <div className="space-y-2.5">
          {items.map((c, i) => (
            <div key={i} className="maqam-card flex items-center gap-3 rounded-2xl p-4" data-testid={`laundry-${cityLabel}-${i}`}>
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-[#0A192F]/6 text-[#0A192F]">
                <Shirt size={18} strokeWidth={1.7} />
              </span>
              <div className="min-w-0 flex-1">
                <p className="font-display text-sm font-bold text-[#0A192F]">{c.name}</p>
                <p className="truncate text-xs text-slate-500">{c.phone}</p>
              </div>
              <a href={`tel:${String(c.phone).replace(/\s/g, "")}`} className="grid h-9 w-9 place-items-center rounded-full bg-[#0A192F] text-white active:scale-95"><Phone size={15} /></a>
              {c.whatsapp && (
                <a href={`https://wa.me/${String(c.whatsapp).replace(/[^0-9]/g, "")}`} target="_blank" rel="noreferrer" className="grid h-9 w-9 place-items-center rounded-full bg-[#128C7E] text-white active:scale-95"><MessageCircle size={15} /></a>
              )}
            </div>
          ))}
        </div>
      </div>
    ) : null;

  return (
    <SectionLayout id="maps" icon={MapPin}>
      <SectionIntro>{L(data.intro)}</SectionIntro>
      <div className="space-y-3">
        {(data.places || []).map((p) => (
          <a
            key={p.id}
            href={p.mapsUrl || "#"}
            target="_blank"
            rel="noreferrer"
            data-testid={`map-place-${p.id}`}
            className="maqam-card group flex items-center gap-4 rounded-3xl p-5 transition-transform duration-300 hover:-translate-y-1"
          >
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-[#0A192F]/6 text-[#0A192F] transition-colors group-hover:bg-[#0A192F] group-hover:text-[#D4AF37]">
              <MapPin size={20} strokeWidth={1.6} />
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="font-display text-lg font-medium text-[#0A192F]">{L(p.title)}</h3>
              <p className="text-xs text-[#64748B]">{L(p.note)}</p>
            </div>
            <span className="inline-flex shrink-0 items-center gap-1 text-xs font-medium text-[#D4AF37]">
              {t("open")} <ExternalLink size={13} />
            </span>
          </a>
        ))}
      </div>

      {laundry && (
        <>
          <h2 className="mb-1 mt-8 font-display text-xl font-bold text-[#0A192F]">{t("maps.laundry")}</h2>
          {laundry.note && <p className="mb-3 text-sm text-slate-500">{L(laundry.note)}</p>}
          <LaundryList items={laundry.madinah} cityLabel={t("prayer.madinah")} />
          <LaundryList items={laundry.makkah} cityLabel={t("prayer.makkah")} />
        </>
      )}
    </SectionLayout>
  );
};
